import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppsChangedId} from '../../../core/actions/apps.actions';
import {AppsState} from '../../../core/state/apps.state';
import {App, AppId} from '../../../shared/models/app';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {ActivatedRoute} from '@angular/router';
import {SessionService} from '../../../core/services/session.service';
import {PermissionsService} from 'src/core/services/permissions.service';
import {Permission} from '../../../shared/models/fga/permission';
import {ObjectType} from '../../../shared/models/object.model';

@Component({
  selector: 'motn-base-app',
  template: '',
  styleUrls: ['./base-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export abstract class BaseAppComponent implements OnInit, OnDestroy {
  app: App;
  appId: AppId;
  
  protected canChat = false;
  protected canConfigure = false;
  private permissionsChecked = false;

  private appsSub: Subscription;
  private routeSub: Subscription;


  protected constructor(
    protected store: Store<AppState>,
    protected route: ActivatedRoute,
    protected session: SessionService,
    protected permissionsService: PermissionsService,
  ) {
  }


  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe((params) => {
      this.appId = params.get('appId');
      this.store.dispatch(new AppsChangedId(this.appId));

      this.appsSub = this.store.select('apps').subscribe(
        (state: AppsState) => {
          this.app = state.apps.find((a) => {
            return a.ID === this.appId;
          });

          if (this.app) {
            this.updateTitle();
            this.updateAside();
          }
        },
      );
    });

    this.onInit();
    this.loadPermissionsOnce();
  }


  ngOnDestroy() {
    this.routeSub?.unsubscribe();
    this.appsSub?.unsubscribe();

    this.onDestroy();
  }


  protected abstract onInit();


  protected abstract onDestroy();


  protected abstract updateTitle();


  protected abstract updateAside();

  private loadPermissionsOnce() {
    if (this.permissionsChecked || !this.appId) return;

    this.permissionsService.queryPermissions({
      UserID: this.session.userId,
      Permissions: [Permission.CAN_CHAT, Permission.CAN_CONFIGURE],
      ObjectID: this.appId,
      ObjectType: ObjectType.APP,
    }).subscribe(response => {
      this.canChat = response.Results.find(r => r.Permission === Permission.CAN_CHAT)?.Allowed || false;
      this.canConfigure = response.Results.find(r => r.Permission === Permission.CAN_CONFIGURE)?.Allowed || false;
      this.permissionsChecked = true;
      
      // Refresh UI with permissions
      if (this.app) {
        this.updateTitle();
        this.updateAside();
      }
    });
  }
}
